export const API_PREFIX = 'kl-api';
export const DEFAULT_LANGUAGE = 'en';
